import React from 'react';

const TrendingOutlineIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width={24}
      height={24}
      fill='currentColor'
      viewBox='0 0 24 24'
      transform=''
      id='injected-svg'
      {...props}
    >
      {/* Boxicons v3.0.4 https://boxicons.com | License  https://docs.boxicons.com/free */}
      <path d='M9 3H11V21H9z' />
      <path d='M20.71 20.23 16.91 12.08 13.1 3.92 12.2 4.34 11.29 4.77 15.09 12.92 18.9 21.08 19.8 20.66 20.71 20.23z' />
      <path d='M6 3H8V21H6z' />
      <path d='M3 3H5V21H3z' />
    </svg>
  );
};

export default TrendingOutlineIcon;
